import { useDialog } from '@/ui-plus/dialog/use-dialog';
import { authState } from '@/ui-plus/useAuth';
import PhoneValidationForm from '@iframe-widgets/pages/widgets/dialogs/phone-validation/PhoneValidationForm.vue';
import { startRefreshingTokens } from '@api-client/auth/auth';

const dialog = useDialog();

export function showPhoneForm() {
    return new Promise<number>((resolve) => {
        dialog.show({
            title: 'Add your phone',
            closeable: true,
            description: 'Enter your phone number and the 4-digit code we send. You only need to do this once.',
            component: PhoneValidationForm,
            props: {
                showCancel: true,
            },
            onSuccess: () => {
                resolve(1);
            },
            onError: () => {
                resolve(-1);
            },
            onCancel: () => {
                resolve(-1);
            }
        })
    })
}


/** Soft phone prompt: only when unverified. Cancel is ok; re-asks on next page load. */
export async function maybePromptPhone() {
    const payload = authState.value.accessTokenPayload;
    if (payload && payload.hasVerifiedPhoneNumber) return;
    await startRefreshingTokens();
    await new Promise(resolve => setTimeout(resolve, 100));
    const payloadNew = authState.value.accessTokenPayload;
    if (!payloadNew || payloadNew.hasVerifiedPhoneNumber) return;
    await showPhoneForm();
}

// /** Hard: loop until the user has a verified phone number. */
// export async function ensurePhone() {
//     await startRefreshingTokens();
//     while (
//         authState.value.accessTokenPayload
//         && !authState.value.accessTokenPayload.hasVerifiedPhoneNumber
//     ) {
//         await showPhoneForm();
//     }
// }
